<template>
  <div class="container-fluid" style="height: 100vh !important; padding: 0px !important">
    <!-- <div style="background: #8a5ab7; color: #fff; padding: 10px">
      <h5>Bem vindo a ciee</h5>
      <h6>Preencha os campos para iniciarmos o seu atendimento:</h6>
    </div> -->
    <div style="display: flex; flex-direction: column; height: 90vh; padding: 10px">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show" style="
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 10px;
          heigth: 100%;
        ">
        <div style="flex: 1.5">
          <!-- <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
              v-model="form.email"
              :label="t(`email`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
            <v-text-field
              v-model="form.nome"
              :label="t(`nome`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
              <v-text-field
              v-model="form.numero"
              :label="t(`numero`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
               <v-text-field
              v-model="form.matricula"
              :label="t(`matricula`)"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
            
                </v-form> -->

          <!-- <b-form-group id="input-group-1" label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              required
            ></b-form-input>
           
          </b-form-group> -->

          <b-form-group id="input-group-2" label="Olá, aqui é o Marvin e você, como se chama?" label-for="input-2">
            <b-form-input id="input-2" v-model="form.nome" required></b-form-input>
            <!-- <b-form-invalid-feedback :state="validationName"
              >Campo obrigatório</b-form-invalid-feedback
            >
            <b-form-valid-feedback
              :state="validationName"
            ></b-form-valid-feedback> -->
          </b-form-group>

          <b-form-group id="input-group-3" label="Telefone" label-for="tel">
            <b-form-input
              id="tel"
              v-model="form.numero"
              required
            ></b-form-input>
            
          </b-form-group>

          <!-- <b-form-group
            id="input-group-2"
            label="Cidade/Estado"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="form.cidade"
              :state="validationCidade"
            ></b-form-input>
            <b-form-invalid-feedback :state="validationCidade"
              >Campo obrigatório</b-form-invalid-feedback
            >
            <b-form-valid-feedback
              :state="validationCidade"
            ></b-form-valid-feedback>
          </b-form-group> -->

          <!-- <b-form-group
            id="input-group-4"
            label="Tipo de contato"
            label-for="input-4"
          >
            <b-form-select id="input-4" v-model="form.tipo" required>
              <option value="chat_reserva">Central de reservas</option>
              <option value="chat_elogios">Comercial/Parcerias</option>
              <option value="chat_infracoes">Infrações de Trânsito</option>
            </b-form-select>
          </b-form-group> -->
        </div>
        <div style="flex: 0.5">
          <b-button type="submit" size="lg" style="
              border-radius: 10px;
              width: 100%;
              background: #8a5ab7;
              color: #fff;
            ">Iniciar Chat</b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("Atendimento");
import Swal from "sweetalert2";

export default {
  data () {
    return {
      form: {
        email: null,
        nome: null,
        tipo: "Marvin",
        numero: null,
      },
      show: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    validationEmail () {
      if (this.form.email && this.form.email.indexOf("@") !== -1) {
        return true;
      } else {
        return false;
      }
    },
    validationName () {
      if (this.form.nome && this.form.nome.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    validationMatricula () {
      if (this.form.matricula) {
        return (
          this.form.matricula.length > 4 && this.form.matricula.length < 13
        );
      } else {
        return false;
      }
    },
    validationCidade () {
      if (this.form.cidade && this.form.cidade.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    validationTelefone () {
      if (this.form.numero && this.form.numero.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  created () {
    // this.verificaStorage();
    this.removeState();
    localStorage.removeItem("state");
  },
  mounted () {
    // const tel = document.getElementById("tel"); // Seletor do campo de telefone

    // tel.addEventListener("keypress", (e) => mascaraTelefone(e.target.value)); // Dispara quando digitado no campo
    // tel.addEventListener("change", (e) => mascaraTelefone(e.target.value)); // Dispara quando autocompletado o campo

    // const mascaraTelefone = (valor) => {
    //   valor = valor.replace(/\D/g, "");
    //   valor = valor.replace(/^(\d{2})(\d)/g, "($1) $2");
    //   valor = valor.replace(/(\d)(\d{4})$/, "$1-$2");
    //   tel.value = valor; // Insere o(s) valor(es) no campo
    // };
  },
  methods: {
    ...mapActions(["login", "setState", "getState", "removeState"]),
    onSubmit (evt) {
      evt.preventDefault();
      // this.form.numero = this.form.numero.replace(/[^0-9]+/g, "");
      this.form.uid = this.form.numero.replace(/[^0-9]+/g, "");
      this.login(this.form);
      this.$router.push("/chat");
    },
    onReset (evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.uid = "";
      this.form.nome = "";
      this.form.numero = "";
      this.form.numero = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    verificaStorage () {
      if (localStorage.getItem("state")) {
        // this.setState();
        Swal.fire({
          title: "Alerta!",
          text: "Verifiquei que você já possui uma sessão de chat aberta, gostaria de continuar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.value) {
            Swal.fire("Alerta", "Sua sessão foi restaurada", "success");
            this.getState();
            this.$router.push("/chat");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire("Alerta", "preencha os dados para prosseguir", "error");
            this.removeState();
            localStorage.removeItem("state");
          }
        });
      }
    },
  },
};
</script>